import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cap-rate-calculator',
  component: () => import('../../routes/CapRate.svelte'),
  card: {
    id: 'cap-rate-calculator',
    title: 'Cap Rate Calculator',
    description: 'Calculate capitalization rate and property valuation based on net operating income (NOI). Essential for real estate investors.',
    icon: 'real_estate_agent',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/cap-rate-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Cap Rate Calculator – Real Estate Capitalization Rate Calculator',
    description: 'Free cap rate calculator for real estate investors. Calculate capitalization rate (cap rate), net operating income (NOI), and property valuation. Enter property value, rental income, and operating expenses to analyze investment properties.',
  },
};

export default meta;
